import { useState } from 'react';
import './login.styles.scss';
import CustomButton from '../../common/custom-button/custom-button.component';
import FormInput from '../../common/form-input/form-input.component';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LOGIN_API } from './api';

const Login = ({ onLogin }) => {
  const initialFormData = {
    userId: '',
    password: '',
  };

  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState(null); // For error handling

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Validation: Check if fields are empty
  //   if (!formData.userId.trim() || !formData.password.trim()) {
  //     setError('User ID and Password are required');
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(LOGIN_API, formData);

  //     if (response.status === 200) {
  //       console.log('Login successful:', response.data);

  //       // Store user session (optional)
  //       localStorage.setItem('token', response.data.token);

  //       // Update authentication state
  //       onLogin(true);

  //       // Redirect to Laboratory page
  //       navigate('/laboratory');

  //       if (username.trim()) {
  //         onLogin(username); // Pass username to App.js
  //       }
  //     } else {
  //       setError('Invalid credentials');
  //     }
  //   } catch (error) {
  //     setError('Login failed. Please try again.');
  //     console.error('Error logging in:', error.response?.data || error.message);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if fields are empty
    if (!formData.userId.trim() || !formData.password.trim()) {
      setError('User ID and Password are required');
      return;
    }

    try {
      const response = await axios.post(LOGIN_API, formData);
      console.log(response);
      if (response.status === 200 && response.data.userID) {
        console.log('Login successful:', response.data);

        // Store user session (optional)
        localStorage.setItem('token', response.data.token);

        // Update authentication state
        onLogin(formData.userId); // Pass userId instead of boolean

        // Redirect to Laboratory page
        navigate('/laboratory');
        // navigate('/purchase');
      } else {
        setError('Invalid credentials'); // Show error instead of redirecting
      }
    } catch (error) {
      setError('Invalid credentials'); // Generic error message for wrong credentials
      console.error('Error logging in:', error.response?.data || error.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className='login-container'>
      <div className='button-row'>
        <h2>Login</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <FormInput
          label='User Id'
          type='text'
          name='userId'
          placeholder='Enter User ID'
          value={formData.userId}
          handleChange={handleInputChange}
          required
        />
        <FormInput
          label='Password'
          type='password'
          name='password'
          placeholder='Enter Password'
          value={formData.password}
          handleChange={handleInputChange}
          required
        />
        {error && <p className='error-message'>{error}</p>}{' '}
        {/* Display error if fields are empty */}
        <div className='button-row'>
          <CustomButton type='submit'>Login</CustomButton>
        </div>
      </form>
    </div>
  );
};

export default Login;
